<template>
  <div class="detail-page" @scroll="scrollFunc">
    <planning-nav/>
    <div class="content-main" >
      <p class="planning-name">
        {{detailData && detailData.profession_name || '未知职类'}}
      </p>
      <p class="planning-name-desc">
        {{detailData && detailData.profession_desc || ''}}
      </p>
      <detail-level :level="position_level"/>
      <detail-background :background-data="backgroundData"/>
      <!-- <detail-skill :skills="skills"/> -->
      <job-direction ref="jobDirectionRef" v-if="showJobDirection" :skills="skills" :lev2Id="profession_id" :cv_token="cv_token"/>
      <detail-recommend-jobs :profession-name="detailData && detailData.profession_name || ''"/>
    </div>
    <img src="https://files.wondercv.com/PC/editor/planning/jobs/bg.png" alt="" class="background-image">
    <robot :cv_token="cv_token" :showRobotContent="showRobot" :typeStr="'jobContrast'" :delayed="100"></robot>
  </div>
</template>

<script>
  import PlanningNav from  "../components/planning-nav"
  import DetailLevel from "../components/detail-level"
  import DetailBackground from "../components/detail-background"
  import DetailSkill from "../components/detail-skill"
  import DetailRecommendJobs from "../components/recommend-jobs"
  import JobDirection from '../components/job-directions.vue'
  import api from "../../../api";
  import Robot from '../components/robot.vue'
  export default {
    name: "planning-detail",
    data(){
      return {
        detailData: null,
        skills: {
          all: [],
          me: []
        },
        backgroundData: {
          education: {},
          workYear: {},
          level: {},
          edu_degree:"",
          work_year: "",
          position_level: ""
        },
        position_level: "",
        profession_id:"",
        showJobDirection:false,
        cv_token:'',
        showRobot: false
      }
    },
    components: {PlanningNav, DetailLevel, DetailBackground, DetailSkill, DetailRecommendJobs,JobDirection,Robot},
    mounted() {
      this.initData() 
      window.addEventListener('scroll', this.scrollFunc);
      try {
        document.getElementsByTagName('body')[0].className += 'hide-udesk'
      } catch (error) {}
    },
    destroyed(){
      window.removeEventListener('scroll', this.scrollFunc);
    },
    methods: {
      async initData(){
        let profession_id = this.$route.params.token
        let cv_token = this.$route.query.me_token
        let [detail, skills, me] = await Promise.all([api.planning.getProfession(profession_id), api.planning.getProfessionSkill(profession_id), api.planning.getReports({cv_token, profession_id })])
        if(detail.code === 1000 || skills.code === 1000 || me.code === 1000){
          this.detailData = detail.data || {};
          this.skills = {
            all: (skills.data && skills.data.skills) || [],
            me: (me.data && me.data.skills) || []
          }
          this.backgroundData = {
            education: (detail.data && detail.data.edu) || {},
            workYear: (detail.data && detail.data.work) || {},
            level: (detail.data && detail.data.salary) || {},
            edu_degree: (me.data && me.data.edu_degree) || "",
            work_year: (me.data && me.data.work_year) || "",
            position_level: (me.data && me.data.position_level) || ""
          }
          this.position_level = me.data && me.data.position_level || ''
          this.profession_id = profession_id
          this.cv_token = cv_token
          this.showJobDirection = true
          setTimeout(()=>{
            let dom = this.$refs.jobDirectionRef
            console.log(dom.$el.offsetTop);
          },500)
        }else {
          this.$message("服务器异常")
        }
      },
      scrollFunc(e){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(scrollTop);
        if(scrollTop > 1030) {
          this.showRobot = true
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.detail-page{
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: rgba(32, 35, 41, 1);
  padding-top: 100px;
  padding-bottom: 114px;
  position: relative;
  .content-main{
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    .planning-name{
      font-size: 48px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 67px;
      margin-bottom: 10px;
    }
    .planning-name-desc{
      width: 800px;
      height: 40px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 20px;
      margin-bottom: 30px;
    }

  }
  .background-image{
    position: absolute;
    z-index: 0;
    top: 50px;
    width: 500px;
    right:0
  }
}
</style>
